<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Videothèque" />
            <LesVideotheques />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import LesVideotheques from './LesVideotheques.vue';


export default {
    name: 'LesTuteursPage',
    components: {
        NavBar,
        PageTitle,
        LesVideotheques,
        FooterComp,
    }
}
</script>